export default "__VITE_ASSET__CKxO8X$E__"